import React from 'react';

const Press = (props) => {
  const pressItems = props.PressData.map((item, i) =>
    <li className={'press-article-item'} key={'press_item-' + i}>
      <a className={'external-link-lg'} href={item.link} target={'_blank'}>{item.link_text}</a>
      <style jsx>{`
        .press-article-item {
          padding-bottom: 1rem;
        }
        .press-article-item:last-child {
          padding-bottom: 0;
        }
      `}</style>
    </li>
  );
  return (
    <div className={'press-repeater'}>
      <h3 className={'small-header'}>{'Press'}</h3>
      <ul className={'press-articles'}>
        {pressItems}
      </ul>
      <style jsx>{`
        .press-repeater {
          display: flex;
          flex-direction: column;
        }
        .press-articles {
          list-style: none;
        }
      `}</style>
    </div>
  );
};

export default Press;



// WEBPACK FOOTER //
// ./src/components/Press.js